import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { applyPolyfills, defineCustomElements as defineProductMgmtExp } from '@acesso-io/unico-sign-octopus/loader';
import {
  applyPolyfills as applyPolyfills_Signatures,
  defineCustomElements as defineProductMgmtExp_Signatures
} from '@acesso-io/unico-people-signatures-component/loader';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular-ivy';

if (environment.production) {
  enableProdMode();
  Sentry.init({
    dsn: environment.sentry_key,
    integrations: [
      new Sentry.BrowserTracing({
        tracingOrigins: [
          'https://admin.acessorh.com.br/svc2',
          'https://collaborators-api.acessorh.com.br/api/v1',
          'https://collaborator.acessorh.com.br/api/v1'
        ],
        routingInstrumentation: Sentry.routingInstrumentation
      })
    ],
    tracesSampleRate: 0.01 // Capture 100% of the transactions, reduce in production!
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

applyPolyfills().then(() => {
  defineProductMgmtExp(window);
});

applyPolyfills_Signatures().then(() => {
  defineProductMgmtExp_Signatures(window);
});
